import Vue from 'vue'
import Router from 'vue-router'
import Top from './components/views/Top.vue'
import Profile from './components/views/Profile.vue'
import HelloWorld from './components/HelloWorld.vue'


Vue.use(Router) 
//useはプラグインを適用すると言う意味
//プラグインとはグローバルな機能を提供する物

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/Profile',
      name: 'Profile',
      component: Profile
    },
  ]
})